import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-registration',
  templateUrl: './mobile-registration.component.html',
  styleUrls: ['./mobile-registration.component.scss']
})
export class MobileRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
